import React, { FC } from 'react'

import { Txt, DecorationTitle, Card, LoadingIcon } from 'src/components/atoms'
import { IpRestrictionToggle } from 'src/components/molecules'
import { AllowedIps } from 'src/components/organisms'

import { useGetIpRestriction } from 'src/hooks'

type Props = {
  className?: string
}

export const IpRestrictionSetting: FC<Props> = ({ className }) => {
  const { ipRestriction, loading, refetch } = useGetIpRestriction()

  const handleAfterToggleIpRestriction = async () => {
    await refetch()
  }

  const handleAfterCrud = async () => {
    await refetch()
  }

  return (
    <div className={className}>
      <Card padding="--s1">
        <div className="tw-full-justify">
          <DecorationTitle sizeType="l">IPアドレス制限</DecorationTitle>
          {!loading && ipRestriction && (
            <IpRestrictionToggle
              enabled={ipRestriction.isIpRestricted ?? false}
              hasAllowedIp={ipRestriction.allowedIps.length > 0}
              afterUpdate={handleAfterToggleIpRestriction}
            />
          )}
        </div>

        <div>
          <div className="tw-text-standardText-secondary tw-mt-s1">
            <Txt>
              指定されたIPアドレス以外からROOV
              compassにアクセスした際、閲覧可能な情報や機能を制限します。
            </Txt>

            <div className="tw-mt-s1">
              <Txt className="tw-font-bold">制限箇所</Txt>
              <Txt className="tw-mt-s-2">・ ROOV compass管理画面へのアクセス禁止</Txt>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="tw-centering">
            <LoadingIcon className="tw-text-2xl tw-mt-s2" />
          </div>
        ) : (
          <AllowedIps
            allowedIps={ipRestriction?.allowedIps ?? []}
            afterCrud={handleAfterCrud}
            className="tw-mt-s4"
          />
        )}
      </Card>
    </div>
  )
}
